import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";

// sync-start:tablet-max 571143357 apps/khanacademy/src/marketing-content-shared-package/media-queries.ts
const tabletMax = "834px";
// sync-end:tablet-max 0

export const MessageUIToolbar = (props: React.PropsWithChildren<Empty>) => (
    <View style={styles.outerWrapper} testId="message-ui-toolbar">
        <View style={styles.reactionWidget}>{props.children}</View>
    </View>
);

const styles = StyleSheet.create({
    outerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        maxWidth: `min(100%, ${tabletMax})`,
    },
    reactionWidget: {
        backgroundColor: color.white,
        flexDirection: "row-reverse",
        flexWrap: "nowrap",
        justifyContent: "space-between",
        width: "100%",
    },
});
